import * as React from 'react';
import MultiSelectModal from '../../../misc/components/queryTable/MultiSelectModal';
import {
    Query,
    QueryCondition,
    QueryFilter,
    SpirometrySessionMetadata
} from "../../../misc/api/apiTypes";
import { useWebPortalApiClient, useWebPortalLegacyClient } from '../../../misc/api/WebPortalTokenClient';
import { SubjectType } from 'webportalclient';

const SubjectTypeFilterQueryCondition = QueryCondition.Equal;
export const SubjectTypeHeader = "Subject Type";

interface SubjectFilterProps {
    filterMember: string;
    onApply: (member: string, condition: QueryCondition, values: string[]) => void;
    onClose: () => void;
    query: Query<SpirometrySessionMetadata>;
}

const SubjectTypeFilterModal = ({ filterMember, onApply, onClose, query }: SubjectFilterProps): JSX.Element => {

    const GetQueryFilter = (query: Query<SpirometrySessionMetadata>): QueryFilter => {
        return query.Filters.find(filter => filter.Member === filterMember && filter.Condition === SubjectTypeFilterQueryCondition);
    }

    const queryFilter = GetQueryFilter(query) || { Values: [] };

    const [values, setValues] = React.useState<any[]>(queryFilter.Values);

    const [subjectTypes, setSubjectTypes] = React.useState<SubjectType[]>(null);
    const client = useWebPortalApiClient();

    React.useEffect(() => {
        client.client.getSubjectTypes().then(subjectTypes => {
            setSubjectTypes(subjectTypes.value);
        });
    }, []);

    return (<MultiSelectModal header={SubjectTypeHeader + ' Filter'}
        isLoading={!subjectTypes}
        show={true}
        options={subjectTypes}
        valueKey="id"
        labelKey="name"
        values={values}
        onChange={(updatedValues) => {
            setValues(updatedValues.length > 0 ? updatedValues.map(v => v.id) : null);
        }}
        onApply={() => {
            onApply(filterMember, SubjectTypeFilterQueryCondition, values);
        }}
        onClear={() => {
            onApply(filterMember, SubjectTypeFilterQueryCondition, []);
        }}
        onClose={onClose}
    />)
}

export default SubjectTypeFilterModal;
